<template>
    <div class="app has-header">
        <div class="header main">
            <div class="align-left">
                <dateselectionheader :label="monthDisplay" @PrevDate="PreviousDate" @NextDate="NextDate"
                                     @CalendarOpen="toggleDatePicker" @SetToday="SetDateToCurrentDay"/>
            </div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
             <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>
            </div>
        </div>

        <div class="tablecontainer scrollbar-container">
            <div v-if="!loading">
                <datatablesimple :state="dataTableSimpleState"></datatablesimple>
            </div>
        </div>
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>

    </div>
</template>

<script>
import datatablesimple from '../uicomponents/datatablesimple.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'employeeaverageworktimeoverview',
    components: {
        datatablesimple
    },
    data() {
        return {
            loadingText: this.$t('workBalance.averages.loading'),
            employeeMap: {},
            workBalanceMap: {},
            employeeEmployeeContractMap: {},
            dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ().hours(0).minutes(0),
            timeFrameStart: this.$helpers.getMomentTZ().hours(0).minutes(0),
            currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
            currentMonth: this.$helpers.getCurrentMonthMomentTZ().month(),
            currentDate: 1,
            sortByName: true,
            showBonus: false,

            loading: false,


        }
    },
    created: function () {
        this.$helpers.GetStoreSettings();
        if (this.rosterFromTo != null) {
            let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            this.setDateSelection(startDate);
        } else {
            this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ());
        }
        this.refresh(true);
    },
    computed: {
        ...mapGetters([ 'storeId', 'uiDataMap', 'permissions', 'storeSettings', 'rosterFromTo', 'isSuperUser', 'employmentModelMap', 'employeeEmploymentModelMap', 'employeeAvgWorktimeMap', 'allowedContractMap']),
        monthDisplay: function () {
            if (this.timeFrameStart != null) {
                return this.timeFrameStart.format('MMM YYYY');
            } else {
                return '-';
            }
        },
        canEditValues() {
            let val = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id === 11);
                if (perm && perm.level > 2) { //permission to edit balance fields
                    val = true;
                }
            });
            return val;
        },
        extraCostTypeMap() {
            let map = {};
            this.uiDataMap.extraCostTypes.forEach(type => {
                map[type.id] = type;
            })
            return map;
        },
        headerButtons() {
            let view = this;
            let state = {
                buttons: [

                    {
                        type: "block",
                        icon: "fa-sync-alt",
                        click: () => {
                            view.refresh(true)
                        },
                        tooltip: this.$t('global.general.refreshData')
                    },

                ],
                showListIconAlways: true
            };

            state.helperLinks = [
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            ];
            return state;
        },
        sideButtons() {
            let view = this;

            let state= {
                buttons: [
                   
                    {
                        type: "block border-r",
                        icon: "fa-eye",
                        tooltip: this.$t('global.ui.viewOptions'),
                        click: ($event) => {view.OpenMenuDetails($event, this.displayMenuState);},

                    },
                    {
                        show: !this.creatingNewEmployee && !this.editing,
                        type: "block",
                        icon: "fa-bars",
                        tooltip: this.$t('global.ui.additionalOptions'),
                        click: ($event) => {view.OpenMenuDetails($event, this.burgerMenuState)}
                    }
                    
                ]
            };


            return state;
        },
        displayMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [],
                items: []
            };

            let group0 = {
                label: this.$t('global.ui.viewOptions'),
                items: [
                    {
                        closeOnClick: true,
                        icon: this.sortByName? "fa-sort-numeric-down" : "fa-sort-alpha-down",
                        text: this.sortByName? this.$t('global.ui.sortByPersonalNumber') : this.$t('global.ui.sortByName'),
                        disabled: false,
                        show: true,
                        click: () => { view.sortByName = !view.sortByName;}
                    }
                    
                ]
            };

            state.groups.push(group0);
            //state.groups.push(spotGroup);

            return state;
        },
        burgerMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [],
                items: []
            };
            
            let group0 = {
                label: this.$t('global.ui.additionalOptions'),
                items: [


                    {
                        closeOnClick: true,
                        disabled: this.mzConfirmed,
                        icon: "fa-calculator",
                        click: () => { view.OpenUseContractValuesForAvgWorktimePopup(); },
                        show:  true,
                        text: this.$t('workBalance.averages.useContractValues'),
                        title: this.$t('workBalance.averages.useContractValues'),
                    },
                    
                ]
            }


            

            state.groups.push(group0);


            return state;
        },
        remoteIdToEmployeeIdMap(){
            let map = {};
            Object.values(this.employeeMap).forEach(emp => {
                if(emp.remoteId != null){
                    map[emp.remoteId] = emp.id;
                }
            });
            return map;
        },
        employeeIdToAvgEmployeeWorktimeMap() {
            let map = {};
            
            Object.entries(this.employeeAvgWorktimeMap).forEach(([ remoteId, wtValues ]) => {
                

                let employeeId = this.remoteIdToEmployeeIdMap[remoteId];
                if(employeeId != null){
                    let wt = Object.assign({}, wtValues);
                    wt.employeeId = employeeId;
                    map[employeeId] = wt;
                }
                
                
            });
            return map;
        },
        employeeIdToConfirmedEWBMap(){
            let map = {};
            Object.values(this.workBalanceMap).forEach(ewb => {
                map[ewb.employeeId] = ewb.confirmed;
            });
            return map;
        },
        dataTableSimpleState() {
            let view = this;

            let map = this.employeeIdToAvgEmployeeWorktimeMap;
            Object.values(this.employeeMap)
            .filter(emp => emp.remoteId !== null).forEach(employee => {
                if (!map[employee.id]) {
                    map[employee.id] = { employeeId: employee.id, averageMinutes: null, averagePayment: null };
                }
            });

            //only list employees that have an ewb entry
            let data = Object.values(map).filter(e => view.employeeIdToConfirmedEWBMap[e.employeeId] != null);

            data.sort((a, b) => {
                let nameA = view.employeeMap[a.employeeId].lastName + " " + view.employeeMap[a.employeeId].firstName;
                let nameB = view.employeeMap[b.employeeId].lastName + " " + view.employeeMap[b.employeeId].firstName;
                if(!view.sortByName){
                    let personnelIdA = view.employeeMap[a.employeeId].personnelId ? view.employeeMap[a.employeeId].personnelId : '9999999999';
                    let personnelIdB = view.employeeMap[b.employeeId].personnelId ? view.employeeMap[b.employeeId].personnelId : '9999999999';
                    if(personnelIdA === personnelIdB){
                        return nameA.localeCompare(nameB);
                    } else {
                        return personnelIdA.localeCompare(personnelIdB);
                    }

                    
                } else {
                     return nameA.localeCompare(nameB);
                }
               
               
            })

            let state = {};

            let columns = {};
            columns.personnelId = this.$t('workBalance.averages.personnelIdShort');
            columns.name = this.$t('pages.employeeData.name');
            columns.averageMinutes = this.$t('workBalance.averages.hours');
            columns.averagePayment = this.$t('workBalance.averages.hourlyWage');
           
            columns.actions = " ";

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            state.headerMap.personnelId.stylesEntrySum = { color: 'black' }
            state.headerMap.personnelId.sort = false;
            state.headerMap.personnelId.componentStateBuilders = [ data => {
                let employee = view.employeeMap[data.employeeId]
                return {
                    componentType: 'labelc',
                    state: {
                        text: employee.personnelId !== null ? employee.personnelId : '-',
                    },
                    styleLabel: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '',
                        height: 'calc(100% - 10px)'
                    },
                }
            } ];

            state.headerMap.name.stylesEntrySum = { color: 'black' }
            state.headerMap.name.sort = false;
            state.headerMap.name.componentStateBuilders = [ data => {
                let employee = view.employeeMap[data.employeeId]
                return {
                    componentType: 'employeeentry',
                    state: {
                        firstName: employee.firstName,
                        lastName: employee.lastName,
                        employee: data,
                        splitName: true,
                        hideShadow: true,
                        textStyle: { color: 'white', fontSize: '12px', margin: '2.5px' }
                    }
                }
            } ];

            state.headerMap.averagePayment.stylesEntrySum = { color: 'black' }
            state.headerMap.averagePayment.sort = false;
            state.headerMap.averagePayment.componentStateBuilders = [ data => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: data.averagePayment !== null ?
                            ( parseFloat(data.averagePayment) / 100.0 ).toFixed(2) + "€" : this.$t('workBalance.averages.noValue'),
                    },
                    styleLabel: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '',
                        height: 'calc(100% - 10px)'
                    },
                }

            } ];

            state.headerMap.averageMinutes.stylesEntrySum = { color: 'black' }
            state.headerMap.averageMinutes.sort = false;
            state.headerMap.averageMinutes.componentStateBuilders = [ (data, entry) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: data.averageMinutes !== null ? ( parseFloat(data.averageMinutes) / 60.0 ).toFixed(1) : this.$t('workBalance.averages.noValue'),
                    },
                    styleLabel: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '',
                        height: 'calc(100% - 10px)'
                    },
                }

            } ];

            // Actions
            state.headerMap.actions.stylesEntry = { 'justify-content': 'left' };
            if (!this.canEditValues) {
                state.headerMap.actions.componentStateBuilders = [];
            } else {
                state.headerMap.actions.componentStateBuilders = [
                    (data) => {
                        return {
                            componentType: 'buttonc',
                            tooltip: () => {
                                return this.$t('workBalance.averages.editEntry')
                            },
                            disabled: view.employeeIdToConfirmedEWBMap[data.employeeId] === true,
                            type: 'button icon-overlay square',
                            icon: 'fa-edit',
                            styleButton: { margin: '0 2px 0 2px' },
                            customEvents: {
                                click: () => {
                                    if(!view.employeeIdToConfirmedEWBMap[data.employeeId]){
                                       view.EditEmployeeAverageWorktime(data);
                                    }
                                        
                                }
                            }
                        }
                    }
                ];
            }

            let entries = Object.entries(state.headerMap);

            let mainColumnWidth = 30;
            let mainColumns = ["name", "averagePayment", "averageMinutes" ];
            let nameColumns = [ "description" ];
            let nameColumnWidth = 35;

            let actionColumns = [ "actions", "personnelId" ];
            let actionColumnWidth = 5;
            for (let x in entries) {

                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (nameColumns.includes(entries[x][0])) {
                    entries[x][1].width = nameColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }

                entries[x][1].key = entries[x][0];

            }
            state.headerStyles = { position: "sticky", top: 0, zIndex: 10, background: 'var(--sub-menu)' };
            state.heightSubRow = 'fit-content';
            state.rowStyles = { background: '#6d8d23' };
            state.rowStylesCollapsed = { background: 'var(--contrast-1)' };
            state.sumRowStyles = { background: 'var(--sub-menu)' }
            state.alwaysUnfold = false;
            return state;
        },
        currentMonthFrom(){
            let rFrom = new Date(this.rosterFromTo.from);
            let rTo = new Date(this.rosterFromTo.to);
            let diffTime = Math.abs(rTo - rFrom);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let diffDaysHalf = Math.abs(diffDays / 2);
            rFrom.setDate(rFrom.getDate() + diffDaysHalf);
            let from = this.$helpers.getMomentFromValuesUTC(rFrom.getFullYear(), rFrom.getMonth(), 1);
            return from;
        },
        currentMonthFromTZ(){

            let from = this.$helpers.getMomentFromValuesTZ(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 1);
            return from;
        },
        currentMonthTo(){
            if(this.currentMonthFrom){
                let to = this.currentMonthFrom.clone().add(1, 'month');
                return to;
            } else {
                return null;
            }

        },
        currentMonthToTZ(){
            if(this.currentMonthFromTZ){
                let to = this.currentMonthFromTZ.clone().add(1, 'month');
                return to;
            } else {
                return null;
            }

        },
    },
    watch: {
        rosterFromTo(newVal, oldVal) {
            if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
                console.log("CALLING REFRESH FROM ROSTERFROMTO")
                this.refresh(true);
            }
        },
        storeId(newVal, oldVal) {
            if (newVal != oldVal) {
                console.log("Changed storeId: " + newVal);
                console.log("CALLING REFRESH FROM STOREID")
                this.refresh(true);
                this.readyFlag = false;
            }
        }
    },
    // methods that implement data logic.
    methods: {
        initMonthly() {
            this.timeFrameStart = this.dateSelectionStart.clone().startOf('month');
        },
        refresh: function (force = false) {

            if (!this.loading) {
                let view = this;
                this.initMonthly();
                this.loading = true;
                let employeePayload = {
                    ids: []
                }
                return this.$helpers.GetUiDataMap(force)
                .then(() => {
                    return view.$helpers.GetAllowedContractMap(force);
                })
                .then(() => {
                    return view.loadActiveAtEmployees()
                })
                .then(response => {
                    view.updateEmployees(response.data);
                    for (let i = 0; i < response.data.length; i++) {
                        let employee = response.data[i];
                        employeePayload.ids.push(employee.id);
                    }
                     
                    return view.loadEmployeeWorkBalances(employeePayload);
                    
                    
                }).then(response => {
                    view.updateEmployeeWorkBalances(response.data);
                    return view.loadEmployeeContracts(employeePayload);
                })
                .then(response => {
                    view.updateEmployeeContracts(response.data);
                    return view.$helpers.GetAvgEmployeeWorktimeMap(Object.values(view.employeeMap).filter(e => e.remoteId != null).map(e => e.remoteId), true, false);
                }).then(response => {
                    view.loading = false;
                    
                }).catch(function (error) {
                    view.loading = false;
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'))
                    console.log(error)
                });
            }
        },
        setDateSelection(date) {
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;

            this.currentDate = fixedDate.date();
            this.currentMonth = fixedDate.month();
            this.currentYear = fixedDate.year();
            let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
            this.$store.commit('setRosterFromTo', {
                rosterFromTo: rosterFromTo
            });
            this.$forceUpdate();
        },
        PreviousDate() {
            let timeframe = 'month';


            this.timeFrameStart = this.timeFrameStart.add(-1, timeframe).clone();
            this.currentDate = this.timeFrameStart.date();
            this.currentMonth = this.timeFrameStart.month();
            this.currentYear = this.timeFrameStart.year();
            let rosterDate = this.timeFrameStart.clone().startOf('month');
            this.setDateSelection(rosterDate);

            this.$forceUpdate();
        },
        NextDate() {
            let timeframe = 'month';
            this.timeFrameStart = this.timeFrameStart.add(1, timeframe).clone();
            this.currentDate = this.timeFrameStart.date();
            this.currentMonth = this.timeFrameStart.month();
            this.currentYear = this.timeFrameStart.year();
            let rosterDate = this.timeFrameStart.clone().startOf('month');
            this.setDateSelection(rosterDate);

            this.$forceUpdate();
        },
        SetDateToCurrentDay() {
            this.timeFrameStart = this.$helpers.getMomentTZ().startOf('month');
            this.currentDate = this.timeFrameStart.date();
            this.currentMonth = this.timeFrameStart.month();
            this.currentYear = this.timeFrameStart.year();
            this.setDateSelection(this.timeFrameStart);
        },
        toggleDatePicker($event) {
            let view = this;
            let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear);
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: [ 'M' ], date: date },
                {
                    OnDateSelect: (date) => {
                        view.onDatePicked(date)
                    },
                },
                { elRelative: $event ? $event.currentTarget : null });
        },
        onDatePicked(date) {
            this.timeFrameStart = date.clone();
            let rosterDate = this.timeFrameStart.clone().startOf('month');
            this.setDateSelection(rosterDate);
        },
        OpenMenuDetails($event, state) {
            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: state,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        loadActiveAtEmployees: function () {
            let url = '/api/sec/employee';
            let params = {
                storeId: this.$store.state.storeId,
                activeAtFrom: this.currentMonthFrom.clone().add(-1, 'month').format(),
                activeAtTo: this.currentMonthTo.clone().add(1, 'month').format(),
                ewbDate: this.$helpers.getMomentFromValuesUTC(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 1).format(),
                bridgeFutureContract: true //this optional flag is only necessary here to load employees which have contracts in the future, in case an ewb can be created for the current month because the employee worked in the store before
            };


            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        updateEmployees: function (data) {

            let employeeMap = {}

            for (let i = 0; i < data.length; i++) {
                employeeMap[data[i].id] = data[i];
            }

            this.employeeMap = employeeMap;
        },
        loadEmployeeWorkBalances: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: []
                    });
                })
            } else {
                let view = this;
                let url = '/api/sec/employeeworkbalance/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentFromValuesUTC(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 1).format(),
                    to: this.$helpers.getMomentFromValuesUTC(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 2).format(),
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }

        },
        updateEmployeeWorkBalances: function(data) {
            let workBalanceMap = {};
            for (let i = 0; i < data.length; i++) {
                workBalanceMap[data[i].id] = data[i];
            }

            this.workBalanceMap = workBalanceMap;
        },
        loadEmployeeContracts : function(payload) {
            if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
                return new Promise((resolve, reject) => {
                    resolve({data:[]});
                })
            } else {
                let url = '/api/sec/employeecontract/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.currentMonthFromTZ.clone().startOf('week').subtract(1,'days').format(),
                    to: this.currentMonthToTZ.clone().endOf('week').add(1,'days').startOf('day').format(),
                    overlapping: true
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                });
            }

        },
        updateEmployeeContracts(data) {
            let employeeEmployeeContractMap = {};
            for (let i = 0; i < data.length; i++) {
                if(employeeEmployeeContractMap[data[i].employeeId] == null){
                    employeeEmployeeContractMap[data[i].employeeId] = [];
                }
                employeeEmployeeContractMap[data[i].employeeId].push(data[i]);
            }

            this.employeeEmployeeContractMap = employeeEmployeeContractMap;
        },
        getAvgValuesFromContract(employeeId){
            let contracts = this.employeeEmployeeContractMap[employeeId] ? this.employeeEmployeeContractMap[employeeId] : [];
            let overlappingContracts = this.$helpers.GetContractsOverlappingMonth(contracts, this.currentMonthFromTZ.clone().startOf('week').subtract(1,'days'), this.currentMonthToTZ);
            let mainContract = null;
            overlappingContracts.forEach(contract => {

                let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from);
                
                if (!mainContract) {
                    mainContract = contract;
                } else {
                    let mainContractFrom = this.$helpers.getMomentFromStringTZ(mainContract.from);
                    if (contractFrom > mainContractFrom) {
                        mainContract = contract;
                    }
                }
            });
            if(mainContract == null){
                return null;
            } else {
                let dayTimeRegular = mainContract != null ? Math.round((mainContract.weekTimeRegular / mainContract.weekWorkDaysRegular)) : null;
                let hourlyWage = this.$helpers.GetHourlyWageFromContract(mainContract, this.allowedContractMap)
                return { averageMinutes: dayTimeRegular, averagePayment: hourlyWage };
            }
            
        },
        
        OpenUseContractValuesForAvgWorktimePopup() {
            let view = this;
            let employeeItems = Object.values(this.employeeMap).filter(e => e.remoteId != null && this.employeeIdToConfirmedEWBMap[e.id] != null).map(e => {
                return { label: e.lastName + " " + e.firstName, value: e.id, selected: false }
            }).sort((a, b) => a.label.localeCompare(b.label));

            let dataEntries = [
                {
                    label: this.$t('global.ui.allEmployees'),
                    key: 'allEmployees',
                    hidden: false,
                    type: 'bool',
                    value: true,
                },
                {label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, 
                        styleLight: true,
                        items: employeeItems
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        
                        let flag = datafill.entries.find(i => i.key == 'allEmployees').value;
                        
                        if(flag ){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                            
                        }           
                            
                        return entryBeforeUpdate;
                    }
                    
                },
                {
                    label: this.$t('workBalance.averages.useHoursFromContract'),
                    key: 'updateWorkTime',
                    hidden: false,
                    type: 'bool',
                    value: false,
                },
                {
                    label: this.$t('workBalance.averages.useWageFromContract'),
                    key: 'updateWorkValue',
                    hidden: false,
                    type: 'bool',
                    value: true,
                },

            ];

            

            this.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (data) {
                        let employeeIds = [];
                        if(data.allEmployees){
                            employeeIds = employeeItems.map(e => e.value);
                        } else {
                            employeeIds = data.employees;
                        }

                        view.updateAvgValuesFromContract(employeeIds, data.updateWorkTime, data.updateWorkValue);
                    }
                },
                header: this.$t('workBalance.averages.useEmployeeFromContract'),
                expanded: true,
                centered: true
            });
        },
        updateAvgValuesFromContract(employeeIds, updateWorkTime = false, updateWorkValue = false){
            let payloads = [];
            employeeIds.forEach(employeeId => {
                let avgValues = this.getAvgValuesFromContract(employeeId);
                if(avgValues != null){
                    
                    let payload = {
                        employeeId: employeeId,
                    }
                    let currentValues = this.employeeIdToAvgEmployeeWorktimeMap[employeeId]
                    if(updateWorkTime){
                        payload.averageMinutes = avgValues.averageMinutes;
                    } else {
                        if(currentValues != null && currentValues.averageMinutes != null){
                            payload.averageMinutes = currentValues.averageMinutes;
                        } else {
                            payload.averageMinutes = avgValues.averageMinutes;
                        }
                    }

                    if(updateWorkValue){
                        payload.averagePayment = avgValues.averagePayment;
                    } else {
                        if(currentValues != null && currentValues.averagePayment != null){
                            payload.averagePayment = currentValues.averagePayment;
                        } else {
                            payload.averagePayment = avgValues.averagePayment;
                        }
                    }
                    
                    
                    if(payload.averageMinutes != null && 
                       payload.averagePayment != null && 
                       this.employeeMap[employeeId].remoteId != null && 
                       this.employeeIdToConfirmedEWBMap[employeeId] != null && 
                       (this.employeeIdToConfirmedEWBMap[employeeId] === false || this.isSuperUser)){
                        
                        payloads.push(payload);
                    }
                    
                }
            });
            this.updateMultipleAverageWorktimes(payloads);
        },
        updateMultipleAverageWorktimes(payloads){
            let view = this;
            view.loading = true;
            if(payloads.length > 0){
                let data = payloads.pop();
                let minutes = Math.round(data.averageMinutes);
                let payment = data.averagePayment != null ? Math.round(data.averagePayment) : null;
                let empName = view.employeeMap[data.employeeId].lastName + " " + view.employeeMap[data.employeeId].firstName;
                    
                this.$helpers.SaveAvgEmployeeWorktimeForMonth(data.employeeId, this.currentYear, this.currentMonth + 1, minutes, payment)
                .then(() => {
                    let remoteId = view.employeeMap[data.employeeId].remoteId;
                    let payload = {
                        id: remoteId,
                        averageMinutes: minutes,
                        averagePayment: payment
                    }
                    view.$store.commit('setEmployeeAvgWorktimeMapEntry', payload);
                    view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('workBalance.averages.updated', [empName]));
                    view.updateMultipleAverageWorktimes(payloads);
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.averages.updatedError', [empName]))
                    view.updateMultipleAverageWorktimes(payloads);
                })
            } else {
                view.loading = false;
                
            }
        },
        EditEmployeeAverageWorktime(data) {
            let view = this;

            this.PopupEditEmployeeAverageWorktime(
                { currentTarget: null },
                data,
                (data) => {
                    view.EditAverageWorktime(data)
                }
            );
        },
        PopupEditEmployeeAverageWorktime($event, entry, editCallback) {
            let dataEntries = [
                {
                    label: 'EmployeeId',
                    key: 'employeeId',
                    hidden: true,
                    type: 'text',
                    value: entry.employeeId,
                    length: 20
                },
                {
                    label: this.$t('global.ui.hourlyWage'),
                    key: 'averagePayment',
                    hidden: false,
                    type: 'numeric',
                    disabled: false,
                    value: entry.averagePayment != null ? parseFloat(entry.averagePayment / 100.0) : 0
                },
                {
                    label: this.$tc('global.ui.hours', 2),
                    key: 'averageMinutes',
                    hidden: false,
                    type: 'numeric',
                    disabled: false,
                    value: entry.averageMinutes != null ? parseFloat(entry.averageMinutes / 60.0) : 0
                },

            ];

            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: editCallback,
                },
                header: this.$t('workBalance.averages.editEmployee'),
                expanded: true,
                centered: true
            });
        },
        EditAverageWorktime(data, callback) {
            let view = this;
            let minutes = Math.round(data.averageMinutes * 60);
            let payment = data.averagePayment != null ? Math.round(data.averagePayment * 100) : null;
            this.$helpers.SaveAvgEmployeeWorktimeForMonth(data.employeeId, this.currentYear, this.currentMonth + 1, minutes, payment)
            .then(() => {
                let remoteId = view.employeeMap[data.employeeId].remoteId;
                let payload = {
                    id: remoteId,
                    averageMinutes: minutes,
                    averagePayment: payment
                }
                view.$store.commit('setEmployeeAvgWorktimeMapEntry', payload);
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('workBalance.averages.updatedData'));
                

                if (callback) {
                    callback(true);
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.averages.updatedDataError'))
                console.log(error)
                if (callback) {
                    callback(false);
                }
            })
        },
        openExportSelection() {
            let view = this;


            let employeesMapped = Object.values(this.employeeMap)
                .filter(e => Object.values(this.employeeExtraPaymentMap).find(ep => ep.employeeId === e.id) != null)
                .map(e => {
                    return { label: e.lastName + " " + e.firstName, value: e.id, selected: true }
                })
                .sort((a, b) => a.label.localeCompare(b.label));
            let dataEntries = [];
            dataEntries.push({
                label: this.$t('global.ui.selectEmployee'),
                key: 'employees',
                hidden: false,
                type: 'dropdownsearch',
                value: null,
                selectMultiple: true,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: employeesMapped,
                    selectMultiple: true,
                    selectedItems: employeesMapped.filter(item => item.selected),
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar) {

                    },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectEmployee'),
                },
            });


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: '',
                    selectCallback: function (data) {
                        view.generatePdfReport(data, true);
                    }
                },
                header: this.$t('global.ui.exportSelection'),
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        hideModal(ref) {
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },
    }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>
.tablecontainer {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
}

.has-header > .has-header > .scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    top: var(--header-height);
}

.data-table {
    top: 10px;
    position: relative;
}

::-webkit-scrollbar {
    display: none;
}
</style>
